import { render, staticRenderFns } from "./MesaObrasGenericConsultasVecino.vue?vue&type=template&id=7c9b3fae"
import script from "./MesaObrasGenericConsultasVecino.vue?vue&type=script&lang=js"
export * from "./MesaObrasGenericConsultasVecino.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports